<script>

import {asyncAngularInvoke} from '/vodalys/vvuejs'



export default {
  components: {  },
  props: ['component', 'handler'],
  computed: {},
  methods: {
    displayPopup: function () {
        let _zis = this
        asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
            v17Modal.ok($rootScope, $rootElement.find('body'), {
                'title' : 'New features ✨!',
                'rawhtml' : true,
                'content': `<div style="max-width:500px">Hello !<br>
Our lab worked hard to simplify your live event video production and we're happy to propose to you a new interface for our platform. Don't worry, you'll access the same features as the previous version, you'll just find some additional functions !<br>
<br>
The list of the improvements is the following :<br>
- A more comprehensive project family: Studio only project, Player only project and All-in-One complete project <br>
- The new Remote Speaker function is included in the Studio. You'll find it as a new media source on the Studio<br>
- A new powerful Studio interface that will ease your live video production<br>
<br>
Enjoy !<br>
The Vodalys team</div>`,
                okLabel: 'Got it !',
                ok : function()
                {
                    return _zis.handler.action(_zis.component, 'gotit', [])
                }
            })
        })
    },
  },
  mounted : function ()
  {
      if (this.component.already_gotit)
      {
          console.log('already gotit!')
      }
      else
      {         
        setTimeout(()  => {
            this.displayPopup()
        }, 5000)
      }
  }
};


</script>

<template>
<f-button @click="displayPopup()" type="tertiary">New features ✨!</f-button>
</template>
<style lang="scss" scoped>
</style>
